import request from "@/utils/request";

// 查询车辆属性
export function getList({ orderSource }){
  return request({
    url:`/basic/${orderSource}/api/carAttribute/findAllCarAttribute`,
    method:"GET"
  })
}